
import { types, actions } from './requests'
export const GETLABEL_TYPES = {
    ...types('GETLABEL'),
}
export const GETLABEL_ACTIONS = {
    ...actions('GETLABEL'),
}